import { useEffect, useMemo } from "react";
import AutocompleteFormik from "../../../common/components/form/AutocompleteFormik";
import { getIn, useFormikContext } from "formik";
import { VehicleClaimRequiredDocuments } from "../../../types/eventClaim.types";

type Props = {
  name: string;
  className?: string;
}

export function AvailableDocumentEventClaimTypesFormik(props: Props) {
  const { values, setFieldValue } = useFormikContext();
  const currentType = getIn(values, props.name)
  const currentComboboxValue = getIn(values, `${props.name}-combobox`)

  const options = useMemo(() => {
    const dataOptions = [
      { label: 'CRLV do Associado', value: VehicleClaimRequiredDocuments.MEMBER_CRLV },
      { label: 'CNH do Associado ou Condutor', value: VehicleClaimRequiredDocuments.MEMBER_DRIVER_LICENSE },
      { label: 'Boletim de Ocorrência em PDF', value: VehicleClaimRequiredDocuments.INCIDENT_REPORT_PDF },
      { label: 'Comprovante de Pagamento da Última Mensalidade', value: VehicleClaimRequiredDocuments.LAST_PAYMENT_RECEIPT },
      { label: 'CRLV do Terceiro', value: VehicleClaimRequiredDocuments.THIRD_PARTY_CRLV },
      { label: 'CNH do Terceiro', value: VehicleClaimRequiredDocuments.THIRD_PARTY_DRIVER_LICENSE },
      { label: 'Foto complementar da eventualidade', value: VehicleClaimRequiredDocuments.ANOTHER_PHOTO }
    ];
    return dataOptions;
  }, []);

  useEffect(() => {
    if (currentComboboxValue) {
       setFieldValue(props.name, currentComboboxValue.value)
    }
  }, [currentComboboxValue, props.name, setFieldValue])

  useEffect(() => {
    if (currentType) {
   
      const option = options.find(opt => opt.value === currentType);
      if (option && (!currentComboboxValue || currentComboboxValue.value !== currentType)) {
        setFieldValue(`${props.name}-combobox`, option);
      }
    }
  }, [currentType, props.name, setFieldValue, options, currentComboboxValue])

  return (
    <AutocompleteFormik
      className={props.className}
      label="Tipo de documento:"
      name={`${props.name}-combobox`}
      valueProperty="label"
      options={options}
    />
  )
}